import React, { useState } from 'react';
import { cn } from '../../utils/helpers';
import { ConsultantDetails } from './consultant-details.component';
import ConsultantModal from './consultant-modal.component';

function ConsultantCard() {
  const [editMode, setEditMode] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const handleModalOpen = () => {
    if (isOpen) {
      setEditMode(false);
    }
    setIsOpen(!isOpen);
  };

  const handleEditMode = async () => {
    setEditMode(!editMode);
  };

  return (
    <>
      <div
        className={cn(
          ' bg-white  rounded-lg w-full hover:bg-primary-100/50 cursor-pointer transition-all',
          editMode ? '' : ''
        )}
        onClick={handleModalOpen}
      >
        <ConsultantDetails
          handleEditMode={handleEditMode}
          handleModalOpen={handleModalOpen}
        />
      </div>
      <ConsultantModal
        open={isOpen}
        edit={editMode}
        handleModalOpen={handleModalOpen}
        handleEditMode={handleEditMode}
      />
    </>
  );
}

export default ConsultantCard;
